import React, { useEffect, useState } from 'react';
import { useAnimation } from '../context/animationContext';

const AnimatedGradientBackground = () => {
  const { getAnimationTime } = useAnimation();
  const [animationDelay, setAnimationDelay] = useState(0);

  useEffect(() => {
    // Calculate the current position in the animation cycle with minimal delay
    const currentTime = getAnimationTime();
    // Convert to seconds for smoother calculation
    setAnimationDelay(-(currentTime / 1000));

    const styleElement = document.createElement('style');
    styleElement.textContent = `
      @keyframes float1 {
        0%, 100% { transform: translate(0, 0) rotate(0deg); }
        25% { transform: translate(200px, -100px) rotate(90deg); }
        50% { transform: translate(-100px, -200px) rotate(180deg); }
        75% { transform: translate(-200px, 100px) rotate(270deg); }
      }
      @keyframes float2 {
        0%, 100% { transform: translate(0, 0) rotate(0deg); }
        20% { transform: translate(-150px, 100px) rotate(72deg); }
        40% { transform: translate(100px, -150px) rotate(144deg); }
        60% { transform: translate(200px, 50px) rotate(216deg); }
        80% { transform: translate(-50px, 200px) rotate(288deg); }
      }
      @keyframes float3 {
        0%, 100% { transform: translate(0, 0) rotate(0deg); }
        30% { transform: translate(150px, -100px) rotate(108deg); }
        60% { transform: translate(-200px, -50px) rotate(216deg); }
        90% { transform: translate(50px, 150px) rotate(324deg); }
      }
      @keyframes float4 {
        0%, 100% { transform: translate(0, 0) rotate(0deg); }
        25% { transform: translate(-100px, 150px) rotate(90deg); }
        50% { transform: translate(150px, 100px) rotate(180deg); }
        75% { transform: translate(100px, -150px) rotate(270deg); }
      }
      @keyframes float5 {
        0%, 100% { transform: translate(0, 0) rotate(0deg); }
        33% { transform: translate(180px, 120px) rotate(120deg); }
        66% { transform: translate(-120px, -180px) rotate(240deg); }
      }
      @keyframes float6 {
        0%, 100% { transform: translate(0, 0) rotate(0deg); }
        20% { transform: translate(-120px, -80px) rotate(72deg); }
        40% { transform: translate(80px, -120px) rotate(144deg); }
        60% { transform: translate(120px, 80px) rotate(216deg); }
        80% { transform: translate(-80px, 120px) rotate(288deg); }
      }
    `;
    
    document.head.appendChild(styleElement);
    
    // Cleanup function to remove the style element when component unmounts
    return () => {
      document.head.removeChild(styleElement);
    };
  }, [getAnimationTime]);

  return (
    <div className="relative w-full h-full overflow-hidden bg-gradient-to-br from-orange-500 via-yellow-500 to-red-500">
      {/* Blob 1 */}
      <div 
        className="absolute w-72 h-72 rounded-full opacity-70"
        style={{
          background: 'radial-gradient(circle, #ff4757, #ff6348)',
          filter: 'blur(80px)',
          mixBlendMode: 'multiply',
          top: '10%',
          left: '10%',
          animation: 'float1 10s ease-in-out infinite',
          animationDelay: `${animationDelay}s`
        }}
      />
      
      {/* Blob 2 */}
      <div 
        className="absolute w-64 h-64 rounded-full opacity-70"
        style={{
          background: 'radial-gradient(circle, #ffa726, #ffcc02)',
          filter: 'blur(80px)',
          mixBlendMode: 'multiply',
          top: '60%',
          right: '20%',
          animation: 'float2 20s ease-in-out infinite',
          animationDelay: `${animationDelay}s`
        }}
      />
      
      {/* Blob 3 */}
      <div 
        className="absolute w-80 h-80 rounded-full opacity-70"
        style={{
          background: 'radial-gradient(circle, #ff7043, #ff5722)',
          filter: 'blur(80px)',
          mixBlendMode: 'multiply',
          bottom: '20%',
          left: '30%',
          animation: 'float3 15s ease-in-out infinite',
          animationDelay: `${animationDelay}s`
        }}
      />
      
      {/* Blob 4 */}
      <div 
        className="absolute w-48 h-48 rounded-full opacity-70"
        style={{
          background: 'radial-gradient(circle, #ffeb3b, #ffc107)',
          filter: 'blur(80px)',
          mixBlendMode: 'multiply',
          top: '10%',
          right: '40%',
          animation: 'float4 18s ease-in-out infinite',
          animationDelay: `${animationDelay}s`
        }}
      />
      
      {/* Blob 5 */}
      <div 
        className="absolute w-68 h-68 rounded-full opacity-70"
        style={{
          background: 'radial-gradient(circle, #ff8a65, #d84315)',
          filter: 'blur(80px)',
          mixBlendMode: 'multiply',
          top: '50%',
          left: '10%',
          animation: 'float5 22s ease-in-out infinite',
          animationDelay: `${animationDelay}s`
        }}
      />
      
      {/* Blob 6 */}
      <div 
        className="absolute w-76 h-76 rounded-full opacity-70"
        style={{
          background: 'radial-gradient(circle, #ffb74d, #ff9800)',
          filter: 'blur(80px)',
          mixBlendMode: 'multiply',
          bottom: '10%',
          right: '10%',
          animation: 'float6 28s ease-in-out infinite',
          animationDelay: `${animationDelay}s`
        }}
      />
    </div>
  );
};

export default AnimatedGradientBackground;